angular.module('ngApp')
.controller('treeCollectionController', ['$scope', '$rootScope', function ($scope, $rootScope) {
  this.specie = $scope.attrs.specie ? JSON.parse($scope.attrs.specie) : null
}])
